import * as Types from '../../../types/graphql.generated';

import { gql } from '@apollo/client';
import { EventFragmentDoc } from '../../fragments/generated/event.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateEventMutationVariables = Types.Exact<{
  name: Types.Scalars['String'];
  description?: Types.InputMaybe<Types.Scalars['String']>;
  image?: Types.InputMaybe<Types.Scalars['ID']>;
  locale: Types.Scalars['String'];
  start?: Types.InputMaybe<Types.Scalars['DateTime']>;
  end?: Types.InputMaybe<Types.Scalars['DateTime']>;
  fullDay?: Types.InputMaybe<Types.Scalars['Boolean']>;
  status?: Types.InputMaybe<Types.StatusTypes>;
  place?: Types.InputMaybe<Types.Scalars['ID']>;
  artist?: Types.InputMaybe<Types.Scalars['ID']>;
  mainEvent?: Types.InputMaybe<Types.Scalars['ID']>;
  location?: Types.InputMaybe<Types.LocationInput>;
  coordinates?: Types.InputMaybe<Types.CoordinateInputOptional>;
  form?: Types.InputMaybe<Types.Scalars['ID']>;
}>;


export type CreateEventMutation = { __typename?: 'Mutation', createEvent: { __typename?: 'Event', id: string, name: string, description?: string | null, fullDay?: boolean | null, start?: string | null, end?: string | null, status?: Types.StatusTypes | null, locale: string, createdAt: string, updatedAt: string, image?: { __typename?: 'Media', id: string, name: string, locale: string, altText?: string | null, caption?: string | null, originalUrl: string, type: Types.MediaType, mimetype: string, createdAt: string, updatedAt: string, formats: { __typename?: 'Formats', xs: { __typename?: 'MediaFormat', url: string, width: number }, s: { __typename?: 'MediaFormat', url: string, width: number }, m: { __typename?: 'MediaFormat', url: string, width: number }, l: { __typename?: 'MediaFormat', url: string, width: number }, xl: { __typename?: 'MediaFormat', url: string, width: number } } } | null, place?: { __typename?: 'Place', id: string, name: string, status: Types.StatusTypes, locale: string, description?: string | null, createdAt: string, updatedAt: string, image?: { __typename?: 'Media', id: string, name: string, locale: string, altText?: string | null, caption?: string | null, originalUrl: string, type: Types.MediaType, mimetype: string, createdAt: string, updatedAt: string, formats: { __typename?: 'Formats', xs: { __typename?: 'MediaFormat', url: string, width: number }, s: { __typename?: 'MediaFormat', url: string, width: number }, m: { __typename?: 'MediaFormat', url: string, width: number }, l: { __typename?: 'MediaFormat', url: string, width: number }, xl: { __typename?: 'MediaFormat', url: string, width: number } } } | null, coordinates?: { __typename?: 'Coordinate', lat?: number | null, lng?: number | null, name?: string | null } | null } | null, artist?: { __typename?: 'Artist', id: string, name: string, status: Types.StatusTypes, locale: string, description?: string | null, createdAt: string, updatedAt: string, image?: { __typename?: 'Media', id: string, name: string, locale: string, altText?: string | null, caption?: string | null, originalUrl: string, type: Types.MediaType, mimetype: string, createdAt: string, updatedAt: string, formats: { __typename?: 'Formats', xs: { __typename?: 'MediaFormat', url: string, width: number }, s: { __typename?: 'MediaFormat', url: string, width: number }, m: { __typename?: 'MediaFormat', url: string, width: number }, l: { __typename?: 'MediaFormat', url: string, width: number }, xl: { __typename?: 'MediaFormat', url: string, width: number } } } | null } | null, mainEvent?: { __typename?: 'MainEvent', id: string, name: string, status: Types.StatusTypes, locale: string, description?: string | null, createdAt: string, updatedAt: string } | null, location?: { __typename?: 'Location', name?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, phone?: string | null, email?: string | null, website?: string | null, information?: string | null } | null, coordinates?: { __typename?: 'CoordinateOptional', lat?: number | null, lng?: number | null, name?: string | null } | null, form?: { __typename?: 'Form', id: string, name: string, status: Types.StatusTypes, locale: string, description: string, content: string, createdAt: string, updatedAt: string } | null } };


export const CreateEventDocument = gql`
    mutation CreateEvent($name: String!, $description: String, $image: ID, $locale: String!, $start: DateTime, $end: DateTime, $fullDay: Boolean, $status: StatusTypes, $place: ID, $artist: ID, $mainEvent: ID, $location: LocationInput, $coordinates: CoordinateInputOptional, $form: ID) {
  createEvent(
    name: $name
    description: $description
    image: $image
    locale: $locale
    place: $place
    artist: $artist
    mainEvent: $mainEvent
    form: $form
    start: $start
    end: $end
    fullDay: $fullDay
    status: $status
    location: $location
    coordinates: $coordinates
  ) {
    ...event
  }
}
    ${EventFragmentDoc}`;
export type CreateEventMutationFn = Apollo.MutationFunction<CreateEventMutation, CreateEventMutationVariables>;

/**
 * __useCreateEventMutation__
 *
 * To run a mutation, you first call `useCreateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventMutation, { data, loading, error }] = useCreateEventMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      image: // value for 'image'
 *      locale: // value for 'locale'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      fullDay: // value for 'fullDay'
 *      status: // value for 'status'
 *      place: // value for 'place'
 *      artist: // value for 'artist'
 *      mainEvent: // value for 'mainEvent'
 *      location: // value for 'location'
 *      coordinates: // value for 'coordinates'
 *      form: // value for 'form'
 *   },
 * });
 */
export function useCreateEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventMutation, CreateEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventMutation, CreateEventMutationVariables>(CreateEventDocument, options);
      }
export type CreateEventMutationHookResult = ReturnType<typeof useCreateEventMutation>;
export type CreateEventMutationResult = Apollo.MutationResult<CreateEventMutation>;
export type CreateEventMutationOptions = Apollo.BaseMutationOptions<CreateEventMutation, CreateEventMutationVariables>;